import Vue from 'vue'
import { API_URL } from '@/config'

export const dashboard = {
  namespaced: true,
  state: {
    sessions: {
      types: {},
      days: {},
    }
  },
  getters: {
    sessions: state => state.sessions,
  },
  mutations: {
    setSessionsPerType(state, types) { state.sessions.types = types },
    setSessionsPerDay(state, days) { state.sessions.days = days },
  },
  actions: {
    getSessionsPerType: () => Vue.axios.get(API_URL + '/statistics/sessionspertype'),
    getSessionsPerDay: () => Vue.axios.get(API_URL + '/statistics/sessionsperday'),
  }
}
